import React, { Component } from 'react';
import _ from 'lodash';
import Header from './Header';
import Modal from './Modal';
import FlashCard from './FlashCard';
import FlashCardActions from './FlashCardActions';

import DeckTile from './DeckTile';

export default class Try extends Component {
    constructor(props) {
        super(props);
        this.state = {
            id: null,
            activeCard: null,
            cardQueue: [],
            lightboxMode: "off",
            sessionEndModalOpen: false,
            totalCards: 0,
            activeSession: {"new": 0, "due": 0},
            initializedDebounce: false,
            debounced: null,
            isFlipped: false,
            multichoiceSelected: false
        };
    }

    componentDidMount = () => {
        this.initializedDebounce();
        this.setState({
            id: this.props.deck.id,
            activeCard: this.props.deck.cards[0],
            cardQueue: this.props.deck.cards,
            totalCards: this.props.deck.cards.length,
            activeSession: {"new": this.props.deck.deckTotalCards, "due": this.props.deck.cards.length}
        }, this.initiateImagePreload(this.props.deck));
        if (this.props.deck.cards[0]?.model === 'multichoice') {
            this.addMultichoiceEventListeners();
        }
    }

    componentDidUpdate = (prevProps, prevState) => {
        if (this.state.activeCard !== prevState.card) {
            if (this.state.activeCard?.model === 'multichoice') {
                this.addMultichoiceEventListeners();
            } else {
                this.removeMultichoiceEventListeners();
            }
        }
    }

    componentWillUnmount = () => {
        this.removeMultichoiceEventListeners();
    }

    setMultichoiceSelected = (value) => {
        this.setState({multichoiceSelected: value});
    }

    initiateImagePreload = (data) => {
        this.preloadImages(data.cards);
        data.cards.forEach(obj => {
            this.preloadImagesWithCloudFrontURLs(obj);
        });
    }

    preloadImagesWithCloudFrontURLs = (obj) => {
        for (let key in obj) {
            if (typeof obj[key] === 'object') {
                this.preloadImagesWithCloudFrontURLs(obj[key]);
            } else if (typeof obj[key] === 'string') {
                const htmlElement = document.createElement('div');
                htmlElement.innerHTML = obj[key];
                const images = htmlElement.getElementsByTagName('img');
                for (let i = 0; i < images.length; i++) {
                    const src = images[i].getAttribute('src');
                    if (src && src.includes('cloudfront.net')) {
                        const img = new Image();
                        img.src = src;
                    }
                }
            }
        }
    }

    preloadImages = (objects) => {
        for (let i = 0; i < objects.length; i++) {
            for (let property in objects[i]) {
                if (typeof objects[i][property] === 'string' && objects[i][property].includes('<img')) {
                    const tempElement = document.createElement('div');
                    tempElement.innerHTML = objects[i][property];
                    const images = tempElement.querySelectorAll('img');
                    for (let j = 0; j < images.length; j++) {
                        const image = new Image();
                        image.src = images[j].src;
                    }
                }
            }
        }
    }

    initializedDebounce = () => {
        if (!this.state.initializedDebounce) {
            const debounced = _.debounce(this.keyBinds, 50, { 'leading': true, 'trailing': false })
            window.addEventListener('keydown', debounced)
            this.setState({ initializedDebounce: true, debounced })
        }
    }

    removeKeyBinds = () => {
        if (this.state.initializedDebounce) {
            window.removeEventListener('keydown', this.state.debounced);
        }
    }

    reinitializedKeyBinds = () => {
        if (this.state.initializedDebounce) {
            window.addEventListener('keydown', this.state.debounced)
        }
    }

    handleResponse = (response) => {
        (document.querySelector('.card__text') || {}).scrollTop = 0;
        if (this.state.cardQueue.length === 1) {
            this.setState({ sessionEndModalOpen: true});
        } else {
            let cardQueue = this.state.cardQueue;
            let activeCard;
            if (response === "right" || response === "easy") {
                // Show all New Cards First
                cardQueue = cardQueue.slice(1);
            } else {
                const firstElement = cardQueue.shift();
                cardQueue.push(firstElement);
            }
            activeCard = cardQueue[0];
            this.setState({ activeCard: activeCard, cardQueue: cardQueue, activeSession: {"new": this.props.deck.deckTotalCards, "due": cardQueue.length}}, this.unflipCard());
        }
    }

    keyBinds = (e) => {
        if ((e.code === "Space" || e.keyCode === 32 || e.key === " ") && !this.state.isFlipped) {
            e.preventDefault();
            this.flipCard();
        } else if ((e.code === "Space" || e.keyCode === 32 || e.key === " ") && this.state.isFlipped) {
            e.preventDefault();
            this.toggleLightboxState('off');
            this.handleResponse('right');
        } else if ((e.code === "Digit1" || e.keyCode === 49 || e.key === "1") && this.state.isFlipped) {
            this.toggleLightboxState('off');
            this.handleResponse('wrong');
        } else if ((e.code === "Digit2" || e.keyCode === 50 || e.key === "2") && this.state.isFlipped) {
            this.toggleLightboxState('off');
            this.handleResponse('right');
        } else if ((e.code === "Digit3" || e.keyCode === 51 || e.key === "3") && this.state.isFlipped) {
            this.toggleLightboxState('off');
            this.handleResponse('easy');
        } else if (e.key === "Esc" || e.keyCode === 27 || e.key === "Escape") {
            this.toggleLightboxState('off');
        }
    }

    toggleLightboxState = (lightboxMode) => {
        if (lightboxMode === 'off') {
            this.setState({ lightboxState: 'off' });
        } else if (lightboxMode === '1x') {
            this.setState({ lightboxState: '1x' });
        } else {
            this.setState({ lightboxState: 'off' });
        }
    }

    hideModal = () => {
        this.setState({sessionEndModalOpen: false});
    }

    flipCard = () => {
        this.setState({ isFlipped: true }, () => {
            this.handleMultichoiceHighlighting();
        });
    }

    unflipCard = () => {
        (document.querySelector('.card__text') || {}).scrollTop = 0;
        this.setState({ isFlipped: false }, () => {
            this.handleMultichoiceReseting();
        });
    }

    selectMultichoiceAnswerHandlers = [
        () => this.selectMultichoiceAnswer(0),
        () => this.selectMultichoiceAnswer(1),
        () => this.selectMultichoiceAnswer(2),
        () => this.selectMultichoiceAnswer(3),
        () => this.selectMultichoiceAnswer(4)
    ]

    addMultichoiceEventListeners = () => {
        this.selectMultichoiceAnswerHandlers.forEach((handler, index) => {
            const element = document.getElementById(`choice-${index}`);
            if (element) {
                element.addEventListener('click', handler);
            }
        });
    }

    removeMultichoiceEventListeners = () => {
        this.selectMultichoiceAnswerHandlers.forEach((handler, index) => {
            const element = document.getElementById(`choice-${index}`);
            if (element) {
                element.removeEventListener('click', handler);
            }
        });
    }

    selectMultichoiceAnswer = (choice) => {
        const choiceEl = document.getElementById('choice-' + choice + '-input');
        this.setMultichoiceSelected(true);
        if (choiceEl) {
            choiceEl.checked = true;
            this.flipCard();
        }
    }

    handleMultichoiceHighlighting = () => {
        if (this.state.activeCard?.model === 'multichoice') {
            const multichoiceOptions = document.getElementById('multichoice-options');
            const correctAnswer = this.state.activeCard.multi_choice_answer;
            const correctChoiceEl = document.getElementById(`choice-${correctAnswer}`);
            const checkedChoiceEl = document.querySelector('input[name="multichoice"]:checked')?.parentElement;
            correctChoiceEl?.classList.add('multichoice-correct-answer');
            multichoiceOptions?.classList.add('answer-revealed');
            if (correctChoiceEl !== checkedChoiceEl) {
                checkedChoiceEl?.classList.add('multichoice-incorrect-answer');
            }
        }
    }

    handleMultichoiceReseting = () => {
        if (this.state.activeCard?.model === 'multichoice') {
            // Remove correct answer highlighting
            document.getElementById(`choice-0`)?.classList.remove('multichoice-correct-answer');
            document.getElementById(`choice-1`)?.classList.remove('multichoice-correct-answer');
            document.getElementById(`choice-2`)?.classList.remove('multichoice-correct-answer');
            document.getElementById(`choice-3`)?.classList.remove('multichoice-correct-answer');
            document.getElementById(`choice-4`)?.classList.remove('multichoice-correct-answer');

            // Mark answer as not revealed
            const multichoiceOptions = document.getElementById('multichoice-options');
            multichoiceOptions?.classList.remove('answer-revealed');

            // Uncheck radio button
            const checkedInputEl = document.querySelector('input[name="multichoice"]:checked');
            if (checkedInputEl) {
                checkedInputEl.checked = false;
                checkedInputEl?.parentElement.classList.remove('multichoice-incorrect-answer')
            }
        }
    }

    renderRegisterModal = () => {
        if (this.props.deck.id === "greenberg" || this.props.deck.id === "plastics" || this.props.deck.id === "topscore") {
            return (
                <div className='signup-wrapper'>
                    <div className='signup'>
                        <div>
                            <a className="header__left__logo" href="https://synaptiq.co/"><img src={'./images/' + this.props.deck.logo} alt="Synaptiq Logo"/></a>
                            <p>Create a Synaptiq account to continue learning <strong>{this.props.deck.name}</strong>.</p>
                            <a className='button' href={this.props.deck.headerButtonLink} target="_blank" rel="noreferrer">Unlock Full Deck</a>
                            <div className='or'>OR</div>
                            <a className='button button--secondary' href={this.props.deck.register} target="_blank" rel="noreferrer">Continue Free Trial</a>
                        </div>
                    </div>
                    <div className='add'>
                        <DeckTile
                            id={this.props.deck.id}
                            image={this.props.deck.image}
                            name={this.props.deck.name}
                            description={this.props.deck.description}
                        />
                    </div>
                </div>
            )
        } else {
            return (
                <div className='signup-wrapper'>
                    <div className='signup'>
                        <div>
                            <a className="header__left__logo" href="https://synaptiq.co/"><img src={'./images/' + this.props.deck.logo} alt="Synaptiq Logo"/></a>
                            <p>Create a Synaptiq account to continue learning <strong>{this.props.deck.name}</strong>.</p>
                            <a className='button' href={this.props.deck.register}>Create Synaptiq Account</a>
                        </div>
                    </div>
                    <div className='add'>
                        <h3>Already have an account?</h3>
                        <p>Click the Add to Account button to add to the account you're currently signed into.</p>
                        <DeckTile
                            id={this.props.deck.id}
                            image={this.props.deck.image}
                            name={this.props.deck.name}
                            description={this.props.deck.description}
                            register={this.props.deck.register}
                        />
                    </div>
                </div>
            )
        }
    }

    render() {
        return (
            <div className="layout layout--site">
                <Header
                    type={'try'}
                    deck={this.props.deck.name}
                    logo={this.props.deck.logo}
                    listed={this.props.deck.listed}
                    register={this.props.deck.register}
                    headerButtonLink={this.props.deck.headerButtonLink}
                    headerButtonText={this.props.deck.headerButtonText}
                    percentMastery={Math.round(((this.state.totalCards - this.state.cardQueue.length) / this.state.totalCards) * 100)}
                    activeSession={this.state.activeSession}
                />
                <div className="layout--site__main">
                    <div className='layout layout--study'>
                        <div className="layout--study__main">
                            <FlashCard
                                card={_.defaultTo(this.state.activeCard, {})}
                                isFlipped={this.state.isFlipped}
                                unflipCard={this.unflipCard}
                                removeKeyBinds={this.removeKeyBinds}
                                reinitializedKeyBinds={this.reinitializedKeyBinds}
                                lightboxState={this.state.lightboxState}
                                toggleLightbox={this.toggleLightboxState}
                            />
                            <FlashCardActions
                                card={this.state.activeCard} 
                                isFlipped={this.state.isFlipped} 
                                flipCard={this.flipCard}
                                handleResponse={this.handleResponse}
                                multichoiceSelected={this.state.multichoiceSelected}
                            />
                        </div>
                    </div>
                    {this.state.sessionEndModalOpen && <Modal
                        name={'modal--session-end'}
                        hide={this.hideModal}
                        hideCancel={true}
                        content={this.renderRegisterModal()}
                    />}
                </div>
            </div>
        );
    }
}
